import { createSlice } from '@reduxjs/toolkit';
import { emptyFetchState } from '../emptyState';
import { fetchStatus } from '../status';
import { getAllPublishers } from 'api';

// Then, handle actions in your reducers:
const allPublishersSlice = createSlice({
  name: 'allPublishers',
  emptyFetchState,
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
    allPublishersFetchStart: (state) => {
      state.status = fetchStatus.FETCH_START;
      state.fetching = true;
    },
    allPublishersFetchSuccess: (state, { payload }) => {
      state.status = fetchStatus.FETCH_SUCCESS;
      state.payload = payload;
      state.fetching = false;
    },
    allPublishersFetchFail: (state, { payload }) => {
      state.status = fetchStatus.FETCH_FAIL;
      state.payload = payload;
      state.fetching = false;
      state.error = true;
    },
    allPublishersResetState: (state) => {
      state.payload = null;
      state.fetching = false;
    },
  },
});

// actions generated from the slice, TODO: remove start,success,fail
export const {
  allPublishersFetchStart,
  allPublishersFetchSuccess,
  allPublishersFetchFail,
  allPublishersResetState,
} = allPublishersSlice.actions;

// The reducer
export const allPublishersReducer = allPublishersSlice.reducer;

// Asynchronous thunk action
export const allPublishersFetch = () => (dispatch) => {
  dispatch(allPublishersFetchStart());

  getAllPublishers()
    .then((allPublishers) => {
      dispatch(allPublishersFetchSuccess(allPublishers.data));
    })
    .catch((error) => {
      dispatch(allPublishersFetchFail(error));
    });
};
